<script setup lang="ts">
import { SpinLoader } from '@marketspark/ui';
</script>
<template>
  <SpinLoader />
</template>
